/* eslint-disable-next-line @harmony/stencil/no-tailwind-disable */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import {
  Typography
} from '@one-thd/sui-atomic-components';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { RecommendedCategory } from './RecommendedCategory';

const RecommendedSearches = ({ categories }) => {
  const impressionData = {
    id: '',
    name: 'MagicApronAssistant',
    component: 'MagicApronAssistant',
    type: 'product',
  };

  return (
    <ImpressionProvider data={impressionData}>
      <div data-testid="categories" className="sui-flex sui-gap-3 sui-flex-col sui-mt-4 sui-mb-2">
        <div className="sui-pb-3">
          <Typography variant="h4">Recommended Searches</Typography>
        </div>
        {categories.map((categoryData, index) => (
          <RecommendedCategory
            key={index}
            categoryData={categoryData}
            index={index}
          />
        ))}
      </div>
    </ImpressionProvider>
  );
};

RecommendedSearches.propTypes = {
  categories: arrayOf(shape({
    imageUrl: string,
    href: string,
    searchTerm: string,
    category: arrayOf(string)
  })).isRequired
};

export { RecommendedSearches };
